import React from "react";
import CourierNativeSelect from "../ui/courier-native-select";

export const FormSelectRow = ({
  label,
  name,
  value,
  onChange,
  options = [],
  error,
  required,
  placeholder,
  disabled,
  span
}) => (
  <CourierNativeSelect
    label={label}
    name={name}
    value={value}
    onChange={onChange}
    options={(options || []).filter(o => o.value !== "" && o.value != null)}
    error={error}
    required={required}
    disabled={disabled}
    span={span}
    placeholder={
      placeholder != null ? placeholder : required ? "Select" : "Optional"
    }
  />
);
